module.exports = __webpack_public_path__ + "static/media/bmw-group-logo.ea99184e.png";